import { makeQuery } from 'shared/utilities';
import { IEssentialModel } from 'shared/models';

type RequestType = {
    page?: number,
    perPage?: number,
};

type ResponseType = {
    items: IEssentialModel[];
    page: number;
    pages: number
};

export const essentialsQuery = async function (params: RequestType = {}) {
    return await makeQuery<ResponseType>('/essentials', { params });
}
